interface IRouteUrlListElement {
    name: string;
    path: string;
    stepNum?: PageNavSteps | null | undefined; // 步驟數
    // loadDataRequired?: boolean | null | undefined; // 該頁面加載後是否會打api，載入歷史資料(每個api request前都會檢查伺服器停登訊息)
    requiredLogin?: boolean | null | undefined; // 登入檢查
    leaveProtection?: boolean | null | undefined; // 離開提示
}

enum PageNavSteps {
    UserAuth = 1, // 基本身份驗證
    Contract = 2, // 契約簽署
    RiskWarningContract = 2, // 契約簽署P2
    ContractConfirm = 3, // 契約簽署確認
    IdDocUpload = 4, // 身分證件上傳
    ProofDocUpload = 5, // 出入金帳號約定/財力證明上傳
    FillBasicData = 6, // 基本資料填寫
    JobAssetInvestment = 7, // 職業狀況/資產狀況與投資經驗
    TradingRiskScore = 8, // 交易風險能力評分表
    FuturesKnowledge = 9, // 期貨交易知識認知確認表
    Confirmation = 10, // 資料確認
    Complete = 11, // 完成申請
    StatusOfApply = 12 // 申請開戶進度
}

interface IRouteUrlList {
    [key: string]: IRouteUrlListElement;
}
interface IBaseSite {
    API_ServiceAlert: IRouteUrlListElement;
    API_ConfirmIdleAlert: IRouteUrlListElement;
    API_IdleTimeout: IRouteUrlListElement;
    API_ConfirmServiceAlert: IRouteUrlListElement;
    API_CheckIfLogin: IRouteUrlListElement;
    API_Logout: IRouteUrlListElement;

    Index: IRouteUrlListElement;

    StateError: IRouteUrlListElement;
    API_StateErrorViewData: IRouteUrlListElement;
}
interface ILogin {
    Login: IRouteUrlListElement;
    Captcha: IRouteUrlListElement;
    API_CheckBid: IRouteUrlListElement;

    API_LoginViewData: IRouteUrlListElement;
    API_LoginPostBack: IRouteUrlListElement;
    // FIDO & MOauth
    API_FidoGenerate: IRouteUrlListElement;
    API_FidoAuthenticate: IRouteUrlListElement;
    API_MOauthGenerate: IRouteUrlListElement;
}

interface IUserAuth {
    // 基本身份驗證
    UserAuth: IRouteUrlListElement;
    API_UserAuthViewData: IRouteUrlListElement;
    API_UserAuthPostBack: IRouteUrlListElement;
}

interface IContract {
    // 契約簽署
    Contract: IRouteUrlListElement;
    API_ContractViewData: IRouteUrlListElement;
    API_ContractPostBack: IRouteUrlListElement;

    // 契約簽署 P2 RiskWarningContract
    RiskWarningContract: IRouteUrlListElement;
    API_RiskWarningContractViewData: IRouteUrlListElement;
    API_RiskWarningContractPostBack: IRouteUrlListElement;

    // 契約簽署 確認page
    ContractConfirm: IRouteUrlListElement;
    API_ContractConfirmViewData: IRouteUrlListElement;
    API_ContractConfirmPostBack: IRouteUrlListElement;
}

interface IIdDocUpload {
    // 身分證件上傳
    IdDocUpload: IRouteUrlListElement;
    API_IdDocUpload: IRouteUrlListElement;
    API_IdDocUploadViewData: IRouteUrlListElement;
    IdDocUploadPreview: IRouteUrlListElement;
    API_IdDocUploadPostBack: IRouteUrlListElement;
}

interface IProofDocUpload {
    // ProofDocUpload 出入金帳號約定/財力證明上傳
    ProofDocUpload: IRouteUrlListElement;
    API_ProofDocUploadViewData: IRouteUrlListElement;
    API_ProofDocUpload: IRouteUrlListElement;
    API_ProofDocDelete: IRouteUrlListElement;
    ProofDocUploadPreview: IRouteUrlListElement;
    API_ProofDocUploadPostBack: IRouteUrlListElement;
}

interface IFillBasicData {
    // FillBasicData 基本資料填寫
    FillBasicData: IRouteUrlListElement;
    API_FillBasicDataViewData: IRouteUrlListElement;
    API_FillBasicPostBack: IRouteUrlListElement;

    // API_SendSmsOtp
    API_SendSmsOtp: IRouteUrlListElement;
    API_VerifySmsCode: IRouteUrlListElement;

    // API_SendMailOtp
    API_SendMailOtp: IRouteUrlListElement;
    API_VerifyMailCode: IRouteUrlListElement;

    // API_GetArea
    API_GetArea: IRouteUrlListElement;
}

interface IJobAssetInvestment {
    // JobAssetInvestment
    JobAssetInvestment: IRouteUrlListElement;
    API_JobAssetInvestmentViewData: IRouteUrlListElement;
    API_JobAssetInvestmentPostBack: IRouteUrlListElement;

    API_GetSubJobTitle: IRouteUrlListElement;
}

interface ITradingRiskScore {
    // 交易風險能力評分表
    TradingRiskScore: IRouteUrlListElement;
    API_TradingRiskScoreViewData: IRouteUrlListElement;
    API_TradingRiskScorePostBack: IRouteUrlListElement;
}

interface IFuturesKnowledge {
    // 期貨交易知識認知確認表
    FuturesKnowledge: IRouteUrlListElement;
    API_FuturesKnowledgeViewData: IRouteUrlListElement;
    API_FuturesKnowledgePostBack: IRouteUrlListElement;
}
interface IComplete {
    // 資料確認
    Confirmation: IRouteUrlListElement;
    API_ConfirmationViewData: IRouteUrlListElement;
    API_ConfirmationPostBack: IRouteUrlListElement;

    Complete: IRouteUrlListElement;
    StatusOfApply: IRouteUrlListElement;
    API_StatusOfApplyViewData: IRouteUrlListElement;
}

interface IWebCA {
    // WebCa
    API_GetWebCAInvokeParam: IRouteUrlListElement;
    API_GetSignPkcs7ForContract: IRouteUrlListElement;
    API_GetSignPkcs7ForBasicData: IRouteUrlListElement;
    API_GetCaFilter: IRouteUrlListElement;
}
interface IFuturesRouteList
    extends IRouteUrlList,
        IBaseSite,
        ILogin,
        IUserAuth,
        IContract,
        IIdDocUpload,
        IProofDocUpload,
        IFillBasicData,
        IJobAssetInvestment,
        ITradingRiskScore,
        IFuturesKnowledge,
        IComplete,
        IWebCA {}

const RouteUrlList: IFuturesRouteList = {
    API_ServiceAlert: { name: 'API_ServiceAlert', path: '/api/Base/ServiceAlert' }, // 1.初始化/刷新 session cookie 、 XSRF cookie 2.取得停登訊息
    API_ConfirmIdleAlert: { name: 'API_ConfirmIdleAlert', path: '/api/Base/ConfirmIdleAlert' }, // 延展 session idle timeout
    API_IdleTimeout: { name: 'API_IdleTimeout', path: '/api/Base/IdleTimeout' }, // 前端逾時轉導 redirect action/
    API_ConfirmServiceAlert: {
        name: 'API_ConfirmServiceAlert',
        path: '/api/Base/ConfirmServiceAlert'
    }, // 確認閱讀 停止登入 訊息
    API_CheckIfLogin: { name: 'API_CheckIfLogin', path: '/api/Login/Check' }, // 檢查是否登入
    API_Logout: { name: 'API_Logout', path: '/api/Logout' }, // 登出

    Index: { name: 'Index', path: '/Index', requiredLogin: false, leaveProtection: false }, // Index頁 申請期貨戶您需要準備...
    Login: { name: 'Login', path: '/Login', requiredLogin: false, leaveProtection: false }, // 登入頁
    Captcha: { name: 'Captcha', path: '/api/Captcha', requiredLogin: false, leaveProtection: false }, // Captcha
    API_CheckBid: { name: 'API_CheckBid', path: '/api/Login/CheckBid' }, // 登入頁 檢查單一分公司
    API_LoginViewData: { name: 'API_LoginViewData', path: '/api/Login/ViewData' }, // 登入頁 View Data Api
    API_LoginPostBack: { name: 'API_LoginPostBack', path: '/api/Login/PostBack' }, // 登入

    StateError: { name: 'StateError', path: '/StateError', requiredLogin: false }, // 錯誤訊息畫面
    API_StateErrorViewData: { name: 'API_StateErrorViewData', path: '/api/StateError/ViewData' }, // 錯誤訊息畫面 View Data Api

    // FIDO & MOauth
    API_FidoGenerate: { name: 'API_FidoGenerate', path: '/api/Login/Fido/Generate' },
    API_FidoAuthenticate: { name: 'API_FidoAuthenticate', path: '/api/Login/Fido/Authenticate' },
    API_MOauthGenerate: { name: 'API_MOauthGenerate', path: '/api/Login/MOauth/Generate' },

    // 基本身份驗證
    UserAuth: {
        name: 'UserAuth',
        path: '/UserAuth',
        requiredLogin: false,
        leaveProtection: true,
        stepNum: PageNavSteps.UserAuth
    }, // 基本身份驗證 page
    API_UserAuthViewData: { name: 'API_UserAuthViewData', path: '/api/UserAuth/ViewData' }, // 基本身份驗證 View Data Api
    API_UserAuthPostBack: { name: 'API_UserAuthPostBack', path: '/api/UserAuth/PostBack' }, // 基本身份驗證 下一步 檢查

    // 契約簽署
    Contract: {
        name: 'Contract',
        path: '/Contract',
        requiredLogin: true,
        stepNum: PageNavSteps.Contract
    }, // 契約簽署_1 page
    API_ContractViewData: { name: 'API_ContractViewData', path: '/api/Contract/ViewData' }, // 契約簽署_1 View Data Api
    API_ContractPostBack: { name: 'API_ContractPostBack', path: '/api/Contract/PostBack' }, // 契約簽署_1 下一步

    // 契約簽署(風險預告暨同意書)
    RiskWarningContract: {
        name: 'RiskWarningContract',
        path: '/RiskWarningContract',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: PageNavSteps.RiskWarningContract
    }, // 契約簽署P2
    API_RiskWarningContractViewData: {
        name: 'API_RiskWarningContractViewData',
        path: '/api/RiskWarningContract/ViewData'
    }, // 契約簽署P2 View Data Api
    API_RiskWarningContractPostBack: {
        name: 'API_RiskWarningContractPostBack',
        path: '/api/RiskWarningContract/PostBack'
    }, // 契約簽署P2 下一步

    // 契約簽署確認
    ContractConfirm: {
        name: 'ContractConfirm',
        path: '/ContractConfirm',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: PageNavSteps.RiskWarningContract
    },
    API_ContractConfirmViewData: {
        name: 'API_ContractConfirmViewData',
        path: '/api/ContractConfirm/ViewData'
    }, // 契約簽署確認 View Data Api
    API_ContractConfirmPostBack: {
        name: 'API_ContractConfirmPostBack',
        path: '/api/ContractConfirm/PostBack'
    }, // 契約簽署確認 下一步

    // 身分證件上傳
    IdDocUpload: {
        name: 'IdDocUpload',
        path: '/IdDocUpload',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: PageNavSteps.IdDocUpload
    }, // 身分證件上傳
    API_IdDocUpload: { name: 'API_IdDocUpload', path: '/api/IdDocUpload/Upload' }, // 身分證件上傳
    API_IdDocUploadViewData: { name: 'API_IdDocUploadViewData', path: '/api/IdDocUpload/ViewData' }, // 身分證件上傳 View Data Api
    IdDocUploadPreview: { name: 'IdDocUploadPreview', path: '/api/IdDocUpload/Preview' }, // 身分證件上傳 顯示圖片
    API_IdDocUploadPostBack: { name: 'API_IdDocUploadPostBack', path: '/api/IdDocUpload/PostBack' }, // 身分證件上傳 下一步

    // 出入金帳號約定/財力證明上傳
    ProofDocUpload: {
        name: 'ProofDocUpload',
        path: '/ProofDocUpload',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: PageNavSteps.ProofDocUpload
    }, // 出入金帳號約定/財力證明上傳
    API_ProofDocUploadViewData: {
        name: 'API_ProofDocUploadViewData',
        path: '/api/ProofDocUpload/ViewData'
    }, // 出入金帳號約定/財力證明上傳  View Data Api
    API_ProofDocUpload: { name: 'API_ProofDocUpload', path: '/api/ProofDocUpload/Upload' }, // 財力證明上傳 Data Api
    API_ProofDocDelete: { name: 'API_ProofDocDelete', path: '/api/ProofDocUpload/Delete' }, // 財力證明刪除 Data Api
    ProofDocUploadPreview: { name: 'ProofDocUploadPreview', path: '/api/ProofDocUpload/Preview' }, // 財力證明上傳 顯示圖片
    API_ProofDocUploadPostBack: {
        name: 'API_ProofDocUploadPostBack',
        path: '/api/ProofDocUpload/PostBack'
    }, // 出入金帳號約定/財力證明上傳  下一步

    // 基本資料填寫
    FillBasicData: {
        name: 'FillBasicData',
        path: '/FillBasicData',
        requiredLogin: true,
        stepNum: PageNavSteps.FillBasicData
    }, // 基本資料填寫 page
    API_FillBasicDataViewData: {
        name: 'API_FillBasicDataViewData',
        path: '/api/FillBasicData/ViewData'
    }, // 基本資料填寫 View Data Api

    API_SendSmsOtp: {
        name: 'API_SendSmsOtp',
        path: '/api/SendSmsOtp'
    }, // SendEmailOTP

    API_VerifySmsCode: {
        name: 'API_VerifySmsCode',
        path: '/api/VerifySmsCode'
    }, // VerifySmsCode

    API_SendMailOtp: {
        name: 'API_SendMailOtp',
        path: '/api/SendMailOtp'
    }, // SendEmailOTP

    API_VerifyMailCode: {
        name: 'API_VerifyMailCode',
        path: '/api/VerifyMailCode'
    }, // VerifyMailCode

    API_GetArea: {
        name: 'API_GetArea',
        path: '/api/GetArea'
    }, // 取鄉鎮市
    API_GetSubJobTitle: {
        name: 'API_GetSubJobTitle',
        path: '/api/GetSubJobTitle'
    }, // 職務工作sub選單  職業+徵信 取擔任職務(subIndex)

    API_FillBasicPostBack: { name: 'API_FillBasicPostBack', path: '/api/FillBasicData/PostBack' }, // 基本資料填寫 下一步

    // 職務工作 + 投資經歷
    JobAssetInvestment: {
        name: 'JobAssetInvestment',
        path: '/JobAssetInvestment',
        requiredLogin: true,
        stepNum: PageNavSteps.JobAssetInvestment
    },
    API_JobAssetInvestmentViewData: {
        name: 'API_JobAssetInvestmentViewData',
        path: '/api/JobAssetInvestment/ViewData'
    },
    API_JobAssetInvestmentPostBack: {
        name: 'API_JobAssetInvestmentPostBack',
        path: '/api/JobAssetInvestment/PostBack'
    },
    // 交易風險能力評分表
    TradingRiskScore: {
        name: 'TradingRiskScore',
        path: '/TradingRiskScore',
        requiredLogin: true,
        stepNum: PageNavSteps.TradingRiskScore
    },
    API_TradingRiskScoreViewData: {
        name: 'API_TradingRiskScoreViewData',
        path: '/api/TradingRiskScore/ViewData'
    },
    API_TradingRiskScorePostBack: {
        name: 'API_TradingRiskScorePostBack',
        path: '/api/TradingRiskScore/PostBack'
    },

    // 期貨交易知識認知確認表
    FuturesKnowledge: {
        name: 'FuturesKnowledge',
        path: '/FuturesKnowledge',
        requiredLogin: true,
        stepNum: PageNavSteps.FuturesKnowledge
    },
    API_FuturesKnowledgeViewData: {
        name: 'API_FuturesKnowledgeViewData',
        path: '/api/FuturesKnowledge/ViewData'
    },
    API_FuturesKnowledgePostBack: {
        name: 'API_FuturesKnowledgePostBack',
        path: '/api/FuturesKnowledge/PostBack'
    },

    // 資料確認
    Confirmation: {
        name: 'Confirmation',
        path: '/Confirmation',
        requiredLogin: true,
        stepNum: PageNavSteps.Confirmation
    },
    API_ConfirmationViewData: {
        name: 'API_ConfirmationViewData',
        path: '/api/Confirmation/ViewData'
    },
    API_ConfirmationPostBack: {
        name: 'API_ConfirmationPostBack',
        path: '/api/Confirmation/PostBack'
    },
    // 完成申請
    Complete: {
        name: 'Complete',
        path: '/Complete',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: PageNavSteps.Complete
    }, // 完成申請 page

    // 申請開戶進度
    StatusOfApply: {
        name: 'StatusOfApply',
        path: '/StatusOfApply',
        requiredLogin: true,
        leaveProtection: false,
        stepNum: PageNavSteps.StatusOfApply
    }, // 申請開戶進度 page
    API_StatusOfApplyViewData: {
        name: 'API_StatusOfApplyViewData',
        path: '/api/StatusOfApply/ViewData'
    }, // 申請開戶進度 View Data Api

    // webCa shareLibs urls
    API_GetWebCAInvokeParam: {
        name: 'API_GetWebCAInvokeParam',
        path: '/api/cert/GetWebCAInvokeParam'
    }, // 取得WebCA進行憑證操作所需參數
    API_GetSignPkcs7ForContract: {
        name: 'GetSignPkcs7ForContract',
        path: '/api/cert/GetSignPkcs7/Contract'
    }, // 取得簽章明文
    API_GetSignPkcs7ForBasicData: {
        name: 'API_GetSignPkcs7ForBasicData',
        path: '/api/cert/GetSignPkcs7/BasicData'
    }, // 取得簽章明文
    API_GetCaFilter: { name: 'API_GetCaFilter', path: '/api/cert/GetCaFilter' } // 取得簽章 filter
};

/**
 * @todo 取得 route info by url path
 * @param path
 * @returns
 */
const GetRouteDataByUrl = (path: string): IRouteUrlListElement => {
    let targetRouteData = RouteUrlList.StateError;
    for (const key in RouteUrlList) {
        const url: IRouteUrlListElement | null = RouteUrlList[key] || null;

        if (!url) {
            continue;
        }

        const hasMatch: boolean = url.path.toLowerCase().indexOf(path.trim().toLowerCase()) !== -1;
        if (hasMatch) {
            targetRouteData = url;
            break;
        }
    }
    return targetRouteData;
};
export { RouteUrlList, GetRouteDataByUrl };
export type { IRouteUrlListElement, IRouteUrlList };
